let csrfToken = null;

export function getCsrfToken() {
    if (csrfToken === null) {
        const selectorElement = document.querySelector('input[name=csrfmiddlewaretoken]');
        csrfToken = selectorElement.value;
    }

    return csrfToken;
}

/**
 * Creates a new FormData instance containing the CSRF token.
 *
 * @return {FormData} FormData instance with `csrfmiddlewaretoken` key.
 */
export function createFormData() {
    const formData = new FormData();
    formData.set('csrfmiddlewaretoken', getCsrfToken());
    return formData;
}
